var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessoriesLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.1,199.8C45,199.8,0.2,155,0.2,99.9S45,0,100.1,0S200,44.8,200,99.9S155.2,199.8,100.1,199.8z M100.1,7.9 c-50.7,0-92,41.3-92,92s41.3,92,92,92s92-41.3,92-92S150.8,7.9,100.1,7.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.1,180.5c-44.4,0-80.6-36.2-80.6-80.6s36.2-80.6,80.6-80.6s80.6,36.2,80.6,80.6S144.5,180.5,100.1,180.5z  M100.1,23.8c-42,0-76.1,34.1-76.1,76.1S58.1,176,100.1,176s76.1-34.1,76.1-76.1S142.1,23.8,100.1,23.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.8,
    y: 26.1,
    className: "st0",
    width: 4.5,
    height: 9.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.8,
    y: 164.2,
    className: "st0",
    width: 4.5,
    height: 9.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 164.4,
    y: 97.7,
    className: "st0",
    width: 9.5,
    height: 4.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.3,
    y: 97.7,
    className: "st0",
    width: 9.5,
    height: 4.5
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.5,68.7l-5.6-5.5l-27.2,27.6c-1.9-1.4-4.2-2.3-6.7-2.3c-2.4,0-4.6,0.8-6.4,2.1L77.8,79.1L73,85.4 l15.2,11.8c-0.2,0.8-0.3,1.6-0.3,2.5c0,6.1,5,11.1,11.1,11.1s11.1-5,11.1-11.1c0-0.7-0.1-1.3-0.2-2L138.5,68.7z M99,104.2 c-2.5,0-4.6-2.1-4.6-4.6S96.5,95,99,95s4.6,2.1,4.6,4.6C103.6,102.2,101.5,104.2,99,104.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessoriesLight);
export default __webpack_public_path__ + "static/media/accessories_light.e5cc7149911957db50209d70e0bb84b8.svg";
export { ForwardRef as ReactComponent };